/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { SprintDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Get All
 */
export const getSprint = (signal?: AbortSignal) => {
  return customInstance<SprintDto[]>({ url: `/sprint`, method: "GET", signal });
};

export const getGetSprintInfiniteQueryKey = () => {
  return ["infinite", `/sprint`] as const;
};

export const getGetSprintQueryKey = () => {
  return [`/sprint`] as const;
};

export const getGetSprintInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getSprint>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getSprint>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSprintInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSprint>>> = ({
    signal,
  }) => getSprint(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSprint>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSprintInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSprint>>
>;
export type GetSprintInfiniteQueryError = void;

export function useGetSprintInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprint>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprint>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprint>>,
          TError,
          Awaited<ReturnType<typeof getSprint>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprint>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprint>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprint>>,
          TError,
          Awaited<ReturnType<typeof getSprint>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprint>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprint>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetSprintInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprint>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprint>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSprintInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSprintQueryOptions = <
  TData = Awaited<ReturnType<typeof getSprint>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSprint>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSprintQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSprint>>> = ({
    signal,
  }) => getSprint(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSprint>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetSprintQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSprint>>
>;
export type GetSprintQueryError = void;

export function useGetSprint<
  TData = Awaited<ReturnType<typeof getSprint>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSprint>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprint>>,
          TError,
          Awaited<ReturnType<typeof getSprint>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprint<
  TData = Awaited<ReturnType<typeof getSprint>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSprint>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprint>>,
          TError,
          Awaited<ReturnType<typeof getSprint>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprint<
  TData = Awaited<ReturnType<typeof getSprint>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSprint>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetSprint<
  TData = Awaited<ReturnType<typeof getSprint>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSprint>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSprintQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create
 */
export const postSprint = (sprintDto: SprintDto, signal?: AbortSignal) => {
  return customInstance<SprintDto>({
    url: `/sprint`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: sprintDto,
    signal,
  });
};

export const getPostSprintMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSprint>>,
    TError,
    { data: SprintDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSprint>>,
  TError,
  { data: SprintDto },
  TContext
> => {
  const mutationKey = ["postSprint"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSprint>>,
    { data: SprintDto }
  > = (props) => {
    const { data } = props ?? {};

    return postSprint(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSprintMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSprint>>
>;
export type PostSprintMutationBody = SprintDto;
export type PostSprintMutationError = void;

/**
 * @summary Create
 */
export const usePostSprint = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSprint>>,
      TError,
      { data: SprintDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSprint>>,
  TError,
  { data: SprintDto },
  TContext
> => {
  const mutationOptions = getPostSprintMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update
 */
export const putSprintId = (id: number, sprintDto: SprintDto) => {
  return customInstance<SprintDto>({
    url: `/sprint/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: sprintDto,
  });
};

export const getPutSprintIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSprintId>>,
    TError,
    { id: number; data: SprintDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSprintId>>,
  TError,
  { id: number; data: SprintDto },
  TContext
> => {
  const mutationKey = ["putSprintId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSprintId>>,
    { id: number; data: SprintDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putSprintId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSprintIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSprintId>>
>;
export type PutSprintIdMutationBody = SprintDto;
export type PutSprintIdMutationError = void;

/**
 * @summary Update
 */
export const usePutSprintId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSprintId>>,
      TError,
      { id: number; data: SprintDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSprintId>>,
  TError,
  { id: number; data: SprintDto },
  TContext
> => {
  const mutationOptions = getPutSprintIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get By Id
 */
export const getSprintId = (id: number, signal?: AbortSignal) => {
  return customInstance<SprintDto>({
    url: `/sprint/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetSprintIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/sprint/${id}`] as const;
};

export const getGetSprintIdQueryKey = (id?: number) => {
  return [`/sprint/${id}`] as const;
};

export const getGetSprintIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSprintIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSprintId>>> = ({
    signal,
  }) => getSprintId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSprintId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSprintIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSprintId>>
>;
export type GetSprintIdInfiniteQueryError = void;

export function useGetSprintIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintId>>,
          TError,
          Awaited<ReturnType<typeof getSprintId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintId>>,
          TError,
          Awaited<ReturnType<typeof getSprintId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Id
 */

export function useGetSprintIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSprintIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSprintIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getSprintId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSprintId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSprintIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSprintId>>> = ({
    signal,
  }) => getSprintId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSprintId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSprintIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSprintId>>
>;
export type GetSprintIdQueryError = void;

export function useGetSprintId<
  TData = Awaited<ReturnType<typeof getSprintId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSprintId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintId>>,
          TError,
          Awaited<ReturnType<typeof getSprintId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintId<
  TData = Awaited<ReturnType<typeof getSprintId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSprintId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintId>>,
          TError,
          Awaited<ReturnType<typeof getSprintId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintId<
  TData = Awaited<ReturnType<typeof getSprintId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSprintId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Id
 */

export function useGetSprintId<
  TData = Awaited<ReturnType<typeof getSprintId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSprintId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSprintIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteSprintId = (id: number) => {
  return customInstance<boolean>({ url: `/sprint/${id}`, method: "DELETE" });
};

export const getDeleteSprintIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSprintId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSprintId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSprintId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSprintId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSprintId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSprintIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSprintId>>
>;

export type DeleteSprintIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteSprintId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSprintId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSprintId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteSprintIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get All By Phase Id
 */
export const getSprintIdPhase = (id: number, signal?: AbortSignal) => {
  return customInstance<SprintDto[]>({
    url: `/sprint/${id}/phase`,
    method: "GET",
    signal,
  });
};

export const getGetSprintIdPhaseInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/sprint/${id}/phase`] as const;
};

export const getGetSprintIdPhaseQueryKey = (id?: number) => {
  return [`/sprint/${id}/phase`] as const;
};

export const getGetSprintIdPhaseInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintIdPhase>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSprintIdPhaseInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSprintIdPhase>>
  > = ({ signal }) => getSprintIdPhase(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSprintIdPhase>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSprintIdPhaseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSprintIdPhase>>
>;
export type GetSprintIdPhaseInfiniteQueryError = void;

export function useGetSprintIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintIdPhase>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getSprintIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getSprintIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Phase Id
 */

export function useGetSprintIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSprintIdPhaseInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSprintIdPhaseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSprintIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSprintIdPhase>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSprintIdPhaseQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSprintIdPhase>>
  > = ({ signal }) => getSprintIdPhase(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSprintIdPhase>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSprintIdPhaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSprintIdPhase>>
>;
export type GetSprintIdPhaseQueryError = void;

export function useGetSprintIdPhase<
  TData = Awaited<ReturnType<typeof getSprintIdPhase>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSprintIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getSprintIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintIdPhase<
  TData = Awaited<ReturnType<typeof getSprintIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSprintIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getSprintIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintIdPhase<
  TData = Awaited<ReturnType<typeof getSprintIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSprintIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Phase Id
 */

export function useGetSprintIdPhase<
  TData = Awaited<ReturnType<typeof getSprintIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSprintIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSprintIdPhaseQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get All By Release Id
 */
export const getSprintReleaseIdRelease = (
  releaseId: number,
  signal?: AbortSignal,
) => {
  return customInstance<SprintDto[]>({
    url: `/sprint/${releaseId}/release`,
    method: "GET",
    signal,
  });
};

export const getGetSprintReleaseIdReleaseInfiniteQueryKey = (
  releaseId?: number,
) => {
  return ["infinite", `/sprint/${releaseId}/release`] as const;
};

export const getGetSprintReleaseIdReleaseQueryKey = (releaseId?: number) => {
  return [`/sprint/${releaseId}/release`] as const;
};

export const getGetSprintReleaseIdReleaseInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintReleaseIdRelease>>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSprintReleaseIdReleaseInfiniteQueryKey(releaseId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSprintReleaseIdRelease>>
  > = ({ signal }) => getSprintReleaseIdRelease(releaseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!releaseId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSprintReleaseIdReleaseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSprintReleaseIdRelease>>
>;
export type GetSprintReleaseIdReleaseInfiniteQueryError = void;

export function useGetSprintReleaseIdReleaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintReleaseIdRelease>>>,
  TError = void,
>(
  releaseId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
          TError,
          Awaited<ReturnType<typeof getSprintReleaseIdRelease>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintReleaseIdReleaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintReleaseIdRelease>>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
          TError,
          Awaited<ReturnType<typeof getSprintReleaseIdRelease>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintReleaseIdReleaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintReleaseIdRelease>>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Release Id
 */

export function useGetSprintReleaseIdReleaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSprintReleaseIdRelease>>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSprintReleaseIdReleaseInfiniteQueryOptions(
    releaseId,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSprintReleaseIdReleaseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSprintReleaseIdReleaseQueryKey(releaseId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSprintReleaseIdRelease>>
  > = ({ signal }) => getSprintReleaseIdRelease(releaseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!releaseId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSprintReleaseIdReleaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSprintReleaseIdRelease>>
>;
export type GetSprintReleaseIdReleaseQueryError = void;

export function useGetSprintReleaseIdRelease<
  TData = Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
  TError = void,
>(
  releaseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
          TError,
          Awaited<ReturnType<typeof getSprintReleaseIdRelease>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintReleaseIdRelease<
  TData = Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
          TError,
          Awaited<ReturnType<typeof getSprintReleaseIdRelease>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSprintReleaseIdRelease<
  TData = Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Release Id
 */

export function useGetSprintReleaseIdRelease<
  TData = Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSprintReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSprintReleaseIdReleaseQueryOptions(
    releaseId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
